import { ReactNode } from "react";

type RewardFeatureCardProps = {
  icon: ReactNode;
  title: string;
  description: string;
};

export const RewardFeatureCard = ({ icon, title, description }: RewardFeatureCardProps) => {
  return (
    <div className="flex items-center gap-[16px] lg:gap-5 rounded-[24px] lg:rounded-[32px] border-[1px] border-[#333] p-[12px] lg:p-4">
      <div className="flex-shrink-0 flex items-center justify-center w-[64px] h-[64px] lg:w-[94px] lg:h-[94px] rounded-[16px] lg:rounded-[22px] bg-white">
        {icon}
      </div>
      <div>
        <h3 className="text-[#171717] text-[17px] lg:text-[22px] font-medium">{title}</h3>
        <p className="mt-[4px] lg:mt-2 text-[#222] text-[13px] lg:text-[16px]">{description}</p>
      </div>
    </div>
  );
};
